<template>
  <b-navbar v-bind="propsNavbar" v-if="show">
    <b-navbar-brand href="#">
      <b-img
        v-bind="img"
        v-if="img.visible"
      />
      {{ empresa }}
    </b-navbar-brand>
    <b-navbar-toggle target="navbar-toggle-collapse">
      <template v-slot:default="{ expanded }">
        <span :class="iconToggle(expanded)" />
      </template>
    </b-navbar-toggle>
    <b-collapse
      id="navbar-toggle-collapse"
      is-nav
    >
      <b-navbar-nav v-bind="propsNavbarNav">
        <b-nav-item
          :to="item.to"
          v-for="(item, key) in items"
          :key="key"
        >
          {{ item.name }}
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import logo from '@/assets/logo.png'

export default {
  data () {
    return {
      show: false,
      propsNavbar: {
        type: 'dark',
        variant: 'primary',
        toggleable: 'lg'
      },
      propsNavbarNav: {
        tag: 'ul',
        fill: false,
        justified: false,
        align: 'end',
        small: false,
        class: 'col-12'
      },
      empresa: 'HPH Inversiones S.A.S.',
      img: {
        height: '40',
        width: '40',
        src: logo,
        class: 'd-inline-block align-top',
        alt: 'Logo empresa',
        fluid: true,
        visible: false
      },
      icon: {
        iconUp: 'fa fa-chevron-up',
        iconDown: 'fa fa-chevron-down'
      },
      items: [{ to: '/solicitud', name: 'Solicitud' }]
    }
  },
  methods: {
    iconToggle: function (flag) {
      return flag === true ? this.icon.iconUp : this.icon.iconDown
    }
  }
}
</script>
